import React from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Logs } from './components';
const Logs = React.lazy(() => import(/* webpackChunkName: "Logs" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/logs" component={Logs} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Logs/routes.js